<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="48" height="48" rx="8" fill="#F3EFFA"/>
<path d="M7 12C7 9.79086 8.79086 8 11 8L37 8C39.2091 8 41 9.79086 41 12V30C41 32.2091 39.2091 34 37 34H11C8.79086 34 7 32.2091 7 30L7 12Z" fill="url(#paint0_linear_1555_9146)"/>
<rect x="10.25" y="14.25" width="27.5" height="0.5" rx="0.25" fill="#AF9EFF"/>
<rect x="10.25" y="14.25" width="27.5" height="0.5" rx="0.25" stroke="#191C1D" stroke-width="0.5"/>
<rect x="10.25" y="14.25" width="27.5" height="0.5" rx="0.25" stroke="#C4C7C7" stroke-opacity="0.02" stroke-width="0.5"/>
<rect x="10.25" y="14.25" width="27.5" height="0.5" rx="0.25" stroke="#CABEFF" stroke-opacity="0.14" stroke-width="0.5"/>
<rect x="10.25" y="21.25" width="27.5" height="0.5" rx="0.25" fill="#AF9EFF"/>
<rect x="10.25" y="21.25" width="27.5" height="0.5" rx="0.25" stroke="#191C1D" stroke-width="0.5"/>
<rect x="10.25" y="21.25" width="27.5" height="0.5" rx="0.25" stroke="#C4C7C7" stroke-opacity="0.02" stroke-width="0.5"/>
<rect x="10.25" y="21.25" width="27.5" height="0.5" rx="0.25" stroke="#CABEFF" stroke-opacity="0.14" stroke-width="0.5"/>
<rect x="10.25" y="28.25" width="27.5" height="0.5" rx="0.25" fill="#AF9EFF"/>
<rect x="10.25" y="28.25" width="27.5" height="0.5" rx="0.25" stroke="#191C1D" stroke-width="0.5"/>
<rect x="10.25" y="28.25" width="27.5" height="0.5" rx="0.25" stroke="#C4C7C7" stroke-opacity="0.02" stroke-width="0.5"/>
<rect x="10.25" y="28.25" width="27.5" height="0.5" rx="0.25" stroke="#CABEFF" stroke-opacity="0.14" stroke-width="0.5"/>
<rect x="14" y="11" width="4" height="6" rx="2" fill="#7958FF"/>
<rect x="30" y="18" width="4" height="6" rx="2" fill="#7958FF"/>
<rect x="19" y="25" width="4" height="6" rx="2" fill="#7958FF"/>
<rect x="14" y="36" width="20" height="4" rx="2" fill="#7958FF"/>
<defs>
<linearGradient id="paint0_linear_1555_9146" x1="35.5104" y1="10.9792" x2="20.4222" y2="35.5618" gradientUnits="userSpaceOnUse">
<stop stop-color="#F07EFF"/>
<stop offset="1" stop-color="#FFF480"/>
</linearGradient>
</defs>
</svg>
